import { reactive } from 'vue';

/* Global store */
const store = reactive({
	/* Whether the data has been loaded or not */
	ready: false,

	/* Full list of stories */
	stories: [],

	/* List of topics */
	topics: {},

	/* List of industries */
	industries: {},

	/* Current filters */
	filter: {
		topics: [],
		industries: [],
	},

	/* Title currently displayed in the hero, kept in sync by title.js */
	pageTitle: '',
});

export default store;
